import React, { useRef, useEffect } from 'react'
import SbEditable from 'storyblok-react'
import Chart from 'chart.js'

import styles from './styles.module.scss'

const Charts = (props) => {

    const chartRefs = useRef([])

    useEffect(() => {
        chartRefs.current.forEach((chart, i) => {
            
            let labels = []
            let colors = []
            let values = []

            props.blok.chart_items[i].data.forEach(point => {
                labels.push(point.label)
                colors.push(point.color)
                values.push(point.value)
            })

            let myChart = new Chart(chart, {
                type: 'pie',
                options: {
                    legend: {
                        fontFamily: 'Relative Pro Book',
                        display: props.blok.chart_items[i].show_legend
                    }
                },            
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: colors,
                        borderWidth: 0
                    }]
                }
            })
        })
    }, [])

    return (
        <SbEditable content={props.blok}>
            <section className={styles['charts']}>
            <div className='container'>
                <div className='row'>
                    {props.blok.chart_items.map((item, i) => {
                        return (
                            <SbEditable key={item._uid} content={item}>
                                <div className={`col ${styles['charts__list-item']}`}>
                                    <canvas ref={el => chartRefs.current[i] = el} className={styles['charts__chart']}></canvas>
                                    <p className='body'>{item.heading}</p>
                                </div>
                            </SbEditable>
                        )
                    })}
                </div>
            </div>
            </section>
        </SbEditable>
    )
}

export default Charts
